var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24646_76602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24646_76602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 17.5002C3.70833 17.5002 3.31597 17.337 2.98958 17.0106C2.66319 16.6842 2.5 16.2918 2.5 15.8335V4.16683C2.5 3.7085 2.66319 3.31613 2.98958 2.98975C3.31597 2.66336 3.70833 2.50016 4.16667 2.50016H7.66667C7.84722 2.00016 8.14931 1.59738 8.57292 1.29183C8.99653 0.986274 9.47222 0.833496 10 0.833496C10.5278 0.833496 11.0035 0.986274 11.4271 1.29183C11.8507 1.59738 12.1528 2.00016 12.3333 2.50016H15.8333C16.2917 2.50016 16.684 2.66336 17.0104 2.98975C17.3368 3.31613 17.5 3.7085 17.5 4.16683V15.8335C17.5 16.2918 17.3368 16.6842 17.0104 17.0106C16.684 17.337 16.2917 17.5002 15.8333 17.5002H4.16667ZM4.16667 15.8335H15.8333V4.16683H4.16667V15.8335ZM5.83333 14.1668H11.6667V12.5002H5.83333V14.1668ZM5.83333 10.8335H14.1667V9.16683H5.83333V10.8335ZM5.83333 7.50016H14.1667V5.8335H5.83333V7.50016ZM10 3.54183C10.1806 3.54183 10.3299 3.4828 10.4479 3.36475C10.566 3.24669 10.625 3.09738 10.625 2.91683C10.625 2.73627 10.566 2.58697 10.4479 2.46891C10.3299 2.35086 10.1806 2.29183 10 2.29183C9.81944 2.29183 9.67014 2.35086 9.55208 2.46891C9.43403 2.58697 9.375 2.73627 9.375 2.91683C9.375 3.09738 9.43403 3.24669 9.55208 3.36475C9.67014 3.4828 9.81944 3.54183 10 3.54183Z",
    fill: "#475467"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.10b6547b773b28e8320b8fd0aef94952.svg";
export { ForwardRef as ReactComponent };